<template>
  <div class="btn-group">
    <el-button type="primary" v-show="enableShow && need!='del'" size="small" @click="changeAttrInBtnGroup(1)">启用</el-button>
    <el-button v-show="enableShow && need!='del'" size="small" @click="changeAttrInBtnGroup(0)">禁用</el-button>
    <el-button v-show="deletesShow && need!='status'" size="small" @click="deleteDatasInBtnGroup()">删除</el-button>
    <el-button v-show="isUpdate" size="small" @click="updateForm">更新表</el-button>
  </div>
</template>

<style>
  .btn-group button {
    height: 36px;
    padding: 7px 16px !important;
  }
  .btn-group .el-button {
    margin-left: 0;
    margin-right: 10px;
  }
</style>

<script>
  import http from '../../../assets/js/http'

  export default {
    props: ['selectedData', 'type', 'need', 'isUpdate'],
    data() {
      return {

      }
    },
    methods: {
      getUrl() {
        return this.type
      },
      getSelectedIds() {
        let array = []
        _(this.selectedData).forEach((res) => {
          // switch (this.type) {
          //   case 'groups':
          //     array.push(res.group_id)
          //     break
          //   case 'users':
          //     array.push(res.u_id)
          //     break
          //   case 'posts':
          //     array.push(res.p_id)
          //     break
          //   default:
          //     array.push(res.id)
          // }
          array.push(res.id)
        })
        return array
      },
      changeAttrInBtnGroup(cate) {
        if (!this.selectedData.length) {
          _g.toastMsg(this, 'warning', '请勾选数据')
          return
        }
        let url = this.getUrl() + '/enables'
        let data = {
          ids: this.getSelectedIds(),
          status: cate
        }
        this.apiPost(url, data).then((res) => {
          if (res.code == 200) {
            let word = ''
            if (cate == 1) {
              word = '启用'
            } else {
              word = '禁用'
            }
            _g.toastMsg(this, 'success', word + '成功')
            this.$emit('toggleCallback', true)
            setTimeout(() => {
              _g.reloadPage(this)
            }, 1500)
          } else {
            _g.dealError(this, res)
            this.$emit('toggleCallback', false)
          }
        })
      },
      deleteDatasInBtnGroup() {
        if (!this.selectedData.length) {
          _g.toastMsg(this, 'warning', '请勾选数据')
          return
        }
        let url = this.getUrl() + '/deletes'
        // console.log(this.selectedData)
        let data = {
          ids: this.getSelectedIds()
        }
        this.apiPost(url, data).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', res.data)
            if (url.indexOf('rules') > -1) {
              _g.clearVuex('setRules')
            }
            this.$emit('deleteCallback', true)
            setTimeout(() => {
              _g.reloadPage(this)
            }, 1500)
          } else {
            _g.dealError(this, res)
            this.$emit('deleteCallback', false)
          }
        })
      },
      updateForm() {
        this.$emit('setLoading', true)
        if (!this.selectedData.length) {
          _g.toastMsg(this, 'warning', '请勾选数据')
          return
        }
        let url = 'form/models/execute'
        let data = {
          model_id: this.getSelectedIds()
        }
        this.apiPost(url, data).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', res.data)
            setTimeout(() => {
              _g.reloadPage(this)
            }, 1500)
          } else {
            _g.dealError(this, res)
          }
          this.$emit('setLoading', false)
        })
      }
    },
    computed: {
      enableShow() {
        return _g.getHasRule('')
      },
      deletesShow() {
        return _g.getHasRule('')
      }
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// btn-group.vue?e28bccc8